import { Forms } from '@clearkit/icons';
import { CKButton } from 'clearkit';
import { Link } from 'react-router-dom';

import { HomeNextStep } from '../HomeNextStep';

export const StepSetupForms = () => (
  <HomeNextStep>
    <HomeNextStep.Heading>
      Increase your form conversion rates with form enrichment & dynamic form
      shortening
    </HomeNextStep.Heading>
    <HomeNextStep.Description>
      Now that you have Clearbit JS installed, you can shorten forms on your
      website{' '}
    </HomeNextStep.Description>
    <HomeNextStep.Footer>
      <CKButton
        as={Link}
        leftIcon={<Forms />}
        to="/integrations/forms"
        variant="simple"
        variantColor="blue"
      >
        Set up Clearbit Forms
      </CKButton>
      {/**
       * @todo add URL
       * */}
      <CKButton href="/" variant="tertiary" variantColor="blue">
        Learn more
      </CKButton>
    </HomeNextStep.Footer>
  </HomeNextStep>
);
